var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseIcon',{staticClass:"my-1 mr-2",attrs:{"name":"shopping-cart","width":"25","height":"25"}}),_c('h3',[_vm._v(_vm._s(_vm._f("translate")("Warenkorb")))]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 px-1 py-1"},[_c('ShoppingCart')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }